import { Link } from 'react-router-dom';
import { useState } from 'react';
import WhatsAppSelector from '../../../components/feature/WhatsAppSelector';

export default function ProductCategories() {
  const [isMuted, setIsMuted] = useState(true);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');

  const handleCotizar = (productName: string) => {
    setSelectedProduct(productName);
    setWhatsappOpen(true);
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
    const iframe = document.querySelector('iframe') as HTMLIFrameElement;
    if (iframe) {
      const currentSrc = iframe.src;
      if (isMuted) {
        // Activar sonido
        iframe.src = currentSrc.replace('mute=1', 'mute=0');
      } else {
        // Desactivar sonido
        iframe.src = currentSrc.replace('mute=0', 'mute=1');
      }
    }
  };

  const categories = [
    {
      title: 'Diseño y Creación de Páginas Web',
      description: 'Sitios web profesionales y modernos para impulsar tu presencia digital',
      image: 'https://readdy.ai/api/search-image?query=Modern%20web%20design%20and%20development%2C%20professional%20website%20creation%2C%20responsive%20web%20design%2C%20digital%20agency%20services%2C%20clean%20interface%20design%2C%20computer%20screen%20showing%20website%2C%20modern%20workspace%2C%20web%20development%20tools%2C%20creative%20design%20process&width=400&height=300&seq=web-design&orientation=landscape'
    },
    {
      title: 'Volantes y Folletos',
      description: 'Materiales promocionales efectivos para tu negocio',
      image: 'https://readdy.ai/api/search-image?query=Professional%20flyers%20and%20brochures%20design%2C%20colorful%20marketing%20materials%2C%20high%20quality%20paper%20printing%2C%20business%20promotional%20materials%2C%20clean%20layout%20design%2C%20modern%20typography%2C%20vibrant%20colors%2C%20white%20background%2C%20commercial%20printing&width=400&height=300&seq=flyers&orientation=landscape'
    },
    {
      title: 'Tarjetas de Presentación',
      description: 'Diseños únicos que causan una primera impresión memorable',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20business%20cards%20with%20modern%20design%2C%20professional%20printing%20quality%2C%20premium%20paper%20texture%2C%20clean%20minimalist%20layout%2C%20corporate%20identity%20materials%2C%20high-end%20business%20stationery%2C%20white%20background%2C%20sophisticated%20design%20elements&width=400&height=300&seq=business-cards&orientation=landscape'
    },
    {
      title: 'Camisetas Impresas',
      description: 'Textiles personalizados con diseños únicos',
      image: 'https://readdy.ai/api/search-image?query=Custom%20printed%20t-shirts%20with%20vibrant%20designs%2C%20textile%20printing%2C%20apparel%20customization%2C%20high%20quality%20fabric%20printing%2C%20colorful%20graphic%20tees%2C%20professional%20garment%20printing%2C%20white%20background%2C%20modern%20clothing%20design&width=400&height=300&seq=tshirts&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Nuestros Productos y Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Contamos con soluciones creativas de impresión y publicidad que elevan el nivel visual de tu marca.
          </p>
        </div>

        {/* Layout responsivo mejorado */}
        <div className="flex flex-col lg:flex-row gap-8 items-center justify-center">
          {/* Celular con video - Ajustado al formato 9:16 del video */}
          <div className="w-full lg:w-auto flex justify-center">
            <div 
              className="relative bg-gray-900 rounded-[3rem] p-3 shadow-2xl" 
              style={{ width: '315px', height: '560px' }}
            >
              {/* Marco del smartphone */}
              <div className="relative w-full h-full bg-black rounded-[2.5rem] overflow-hidden">
                {/* Notch/Cámara frontal */}
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-6 bg-black rounded-b-3xl z-20"></div>
                
                {/* Área del video - YouTube Shorts */}
                <div className="w-full h-full bg-black flex items-center justify-center rounded-[2.2rem] overflow-hidden">
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/6kVUXMurrqQ?autoplay=1&mute=${isMuted ? '1' : '0'}&loop=1&playlist=6kVUXMurrqQ&controls=0&modestbranding=1&playsinline=1&rel=0`}
                    title="LION URBAN Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ border: 'none' }}
                  ></iframe>
                </div>

                {/* Botón de control de sonido - Esquina inferior izquierda */}
                <button
                  onClick={toggleMute}
                  className="absolute bottom-6 left-6 z-30 bg-black/70 hover:bg-black/90 text-white rounded-full p-3 transition-all duration-300 shadow-lg backdrop-blur-sm cursor-pointer w-12 h-12 flex items-center justify-center"
                  aria-label={isMuted ? 'Activar sonido' : 'Desactivar sonido'}
                >
                  {isMuted ? (
                    <i className="ri-volume-mute-fill text-xl w-6 h-6 flex items-center justify-center"></i>
                  ) : (
                    <i className="ri-volume-up-fill text-xl w-6 h-6 flex items-center justify-center"></i>
                  )}
                </button>

                {/* Botones del smartphone */}
                <div className="absolute right-0 top-20 w-1 h-8 bg-gray-700 rounded-l-lg"></div>
                <div className="absolute right-0 top-32 w-1 h-12 bg-gray-700 rounded-l-lg"></div>
                <div className="absolute right-0 top-48 w-1 h-12 bg-gray-700 rounded-l-lg"></div>
              </div>
            </div>
          </div>

          {/* Grid de productos - Responsivo */}
          <div className="w-full lg:flex-1 lg:max-w-4xl">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {categories.map((category, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group overflow-hidden"
                  style={{ height: '350px' }}
                >
                  <div className="relative h-44 overflow-hidden bg-gray-100">
                    <img
                      src={category.image}
                      alt={category.title}
                      className="w-full h-full object-cover object-top transition-all duration-500 ease-out group-hover:scale-110"
                    />
                  </div>
                  <div className="p-6 h-48 flex flex-col justify-between">
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-3">
                        {category.title}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed mb-4">
                        {category.description}
                      </p>
                    </div>
                    <div className="mt-auto">
                      <button 
                        onClick={() => handleCotizar(category.title)}
                        className="block w-full bg-teal-600 hover:bg-teal-700 text-white py-3 px-4 rounded-lg transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer text-center"
                      >
                        Cotizar
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Ver Todos los Productos Button */}
        <div className="text-center mt-16">
          <Link
            to="/products"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Ver Todos los Productos y Servicios
            <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
          </Link>
          <p className="text-gray-600 mt-4 text-sm">
            Descubre nuestra completa gama de más de 30 productos y servicios de impresión y diseño web
          </p>
        </div>
      </div>
      <WhatsAppSelector 
        isOpen={whatsappOpen} 
        onClose={() => setWhatsappOpen(false)} 
        productName={selectedProduct}
      />
    </section>
  );
}
